import { Task } from 'models/mowerEnvironmentModels';
import { TaskStatus } from 'enums/mowerEnvironment';
import { 
  StyledUl, 
  StyledLi, 
  StyledListItem, 
  StyledCheckCircle, 
  StyledIcon, 
  StyledOutlineCircle, 
  StyledOutlineCancel, 
  StyledInProgress, 
  StyledAnimationInDiv 
} from './styled';

function getStatusIcon(status: TaskStatus) {
  switch (status) {
    case TaskStatus.SUCCESSFUL:
      return (
        <StyledIcon> 
          <StyledCheckCircle /> 
        </StyledIcon>
      );

    case TaskStatus.STARTED:
      return (
        <StyledIcon> 
          <StyledInProgress /> 
        </StyledIcon>
      );

    case TaskStatus.ERROR:
      return (
        <StyledIcon> 
          <StyledOutlineCancel /> 
        </StyledIcon>
      );

    default:
      return (
        <StyledIcon> 
          <StyledOutlineCircle /> 
        </StyledIcon>
      );
  }
}

export const ProgressCheckList = ({ tasks }: { tasks: Task[] }) => {
  return (
    <StyledAnimationInDiv>
      <StyledUl>
        {tasks.map((task) => (
          <StyledListItem key={task.id}>
            {getStatusIcon(task.status)}
            <StyledLi>
              <span>{task.task}</span>
            </StyledLi>
          </StyledListItem>
        ))}
      </StyledUl>
    </StyledAnimationInDiv>
  );
};
